import React from 'react'
import { PumpNozzle } from 'BoostXpressAdmin/Services/fillingStationsService'

interface PumpNozzleSelectorProps {
  value: PumpNozzle[]
  onChange: (nozzles: PumpNozzle[]) => void
}

const NOZZLE_OPTIONS: PumpNozzle[] = ['A', 'B']

const PumpNozzleSelector: React.FC<PumpNozzleSelectorProps> = ({ value, onChange }) => {
  const toggleNozzle = (nozzle: PumpNozzle) => {
    onChange(value.includes(nozzle) ? value.filter((item) => item !== nozzle) : [...value, nozzle])
  }

  return (
    <fieldset className='add-pump-modal__field add-pump-modal__nozzle-field'>
      <legend className='add-pump-modal__label'>Available Nozzles *</legend>
      <p className='add-pump-modal__hint'>
        Select every nozzle attached to this pump. Reports will require readings for each selected
        nozzle.
      </p>
      <div className='add-pump-modal__nozzle-options'>
        {NOZZLE_OPTIONS.map((nozzle) => {
          const isSelected = value.includes(nozzle)

          return (
            <label
              key={nozzle}
              className={`add-pump-modal__nozzle-option ${
                isSelected ? 'add-pump-modal__nozzle-option--selected' : ''
              }`}
            >
              <input type='checkbox' checked={isSelected} onChange={() => toggleNozzle(nozzle)} />
              <span className='add-pump-modal__nozzle-letter'>{nozzle}</span>
              <span className='add-pump-modal__nozzle-name'>Nozzle {nozzle}</span>
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}

export default PumpNozzleSelector
